for (const hubHero of document.querySelectorAll(".adm-section-c6v2")) {
    const jumpBtn = hubHero.querySelector(".adm-btn-c6v2-jump");

    jumpBtn.addEventListener("click", () => {
        const hubHeroBottomPosition = window.scrollY + hubHero.getBoundingClientRect().bottom;

        jumpBtn.blur();
        window.scrollTo({
            top: hubHeroBottomPosition,
            left: 0,
            behavior: "smooth",
        });
    })
}